
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"8","cy":"8","r":"7.5","stroke":"#A2B8C6"}}),_c('path',{attrs:{"d":"M8.316 5.463a.81.81 0 00.816-.805.807.807 0 00-.816-.806.807.807 0 00-.816.806c0 .44.36.805.816.805zM7.537 12h1.568V6.242H7.537V12z","fill":"#A2B8C6"}})])
          )
        }
      }
    